import React, { Component, Fragment } from 'react';
import {
  Container,
  Row, Col, Input, Label, Button, Form, FormGroup
} from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck, faTrashAlt, faTimes, faCircle } from '@fortawesome/free-solid-svg-icons'
import { faCircle as faCircleOutline } from '@fortawesome/free-regular-svg-icons'
import ConfirmButton from '../Modal/ConfirmButton';

class AdminRoles extends Component {

  standardRow = (role) => {
    return (<Row className="adminRow pointer" onClick={() => this.props.onEdit(role.ID)}>
      <Col className="text-left col-md-4">
        <FontAwesomeIcon icon={(role['Active']) ? faCircle : faCircleOutline} className={"mr-3 " + ((role['Active']) ? 'iconActive' : 'iconInactive')} />
        {role['Role']}
      </Col>
      <Col className="text-left col-md-6">{role['Description']}</Col>
      {/* <Col className="text-right col-md-1"><CustomInput type="switch" id={"switch-active"+role.ID} name={"switch-active"+role.ID} /></Col> */}
      {/* <Col className="text-right col-md-2">
        <Button className="mx-1" color="primary" onClick={() => this.props.onEdit(role.ID)}><FontAwesomeIcon icon={faEdit} /></Button>
      </Col> */}
    </Row>
    )
  }

  editRow = (role) => {
    return (
      <Row className="editRow adminRow">
        <Col className="text-left col-md-8">
          <Form inline>
            <FormGroup className="pr-2">
              <Input
                placeholder="Role"
                type="text"
                id={"edit-role" + role.ID}
                name="role"
                value={this.props.editRole.role}
                onChange={e => this.props.onChange(e, 'edit')} />
            </FormGroup>
            <FormGroup className="px-2">
              <Input
                placeholder="Description"
                type={"edit-text" + role.ID}
                id="role-edit-description"
                name="description"
                value={this.props.editRole.description}
                onChange={e => this.props.onChange(e, 'edit')} />
            </FormGroup>
            <FormGroup className="px-2">
              <Input
                type="checkbox"
                id={"role-active" + role.ID}
                name="active"
                checked={this.props.editRole.active}
                onChange={e => this.props.onChange(e, 'edit')} />
              <Label for={"role-active" + role.ID}>
                Active
              </Label>
            </FormGroup>
          </Form>
        </Col>
        <Col className="text-right col-md-4">
          <Button className="mx-1" color="success" onClick={this.props.handleEdit} title="Edit Role">
            <FontAwesomeIcon icon={faCheck} />
          </Button>
          <ConfirmButton className="mx-3" color="danger" onClick={() => this.props.onDelete(role.ID)} title="Delete Role">
            <FontAwesomeIcon icon={faTrashAlt} />
          </ConfirmButton>
          <Button className="mx-1" color="secondary" onClick={this.props.handleCancel} title="Cancel">
            <FontAwesomeIcon icon={faTimes} />
          </Button>
        </Col>
        <Col className="text-right col-md-3 p-3">
          Assigned Permissions
          </Col>
        <Col className="text-left col-md-3 p-3">
          {this.props.permissions.map(permission => (
            <Label key={permission.ID} for={"userPermission_" + permission.ID}>
              <Input
                type="checkbox"
                name="permissions"
                id={"userPermission_"+permission.ID}
                checked={this.props.editRole?.permissions?.findIndex(i => i === parseInt(permission.ID)) > -1}
                onChange={e => this.props.onChange(e, 'edit')}
              />
              {permission.Permission}
            </Label>
          ))}
        </Col>
        <Col className="text-right col-md-3 p-3">
          Assigned Users
          </Col>
        <Col className="text-left col-md-3 p-3">
          {this.props.users.map(user => (
            <Label key={user.Auth0} for={"user_" + user.Auth0}>
              <Input
                type="checkbox"
                name="users"
                id={"user_"+user.Auth0+"_"+role.ID}
                checked={[...this.props.users].filter(o => o.Roles.findIndex(j => j === role.ID) > -1).map(i => i.Auth0).findIndex(u => u === user.Auth0) > -1}
                onChange={e => this.props.onChange(e, 'edit')}
              />
              {user['Full Name']}
            </Label>
          ))}
        </Col>
      </Row>
    )
  }

  addRow = () => {
    return (<Row className="py-4 text-left align-items-bottom">
      <Col>
        <Form inline>
          <FormGroup className="pr-2">
            Add New Role
            </FormGroup>
          <FormGroup className="px-2">
            <Input
              placeholder="Role"
              type="text"
              id="role"
              name="role"
              value={this.props.newRole.role}
              onChange={e => this.props.onChange(e)} />
          </FormGroup>
          <FormGroup className="px-2">
            <Input
              placeholder="Description"
              type="text"
              id="role-add-description"
              name="description"
              value={this.props.newRole.description}
              onChange={e => this.props.onChange(e)} />
          </FormGroup>
          <FormGroup className="px-2">
            <Input
              type="checkbox"
              id="role-active"
              name="active"
              checked={this.props.newRole.active}
              onChange={e => this.props.onChange(e)} />
            <Label for="role-active">
              Active
            </Label>
          </FormGroup>
        </Form>
      </Col>
      <Col className="text-right col-md-3">
        <Button disabled={this.props.newRole.role === ''} color="primary" onClick={this.props.handleAdd}>Add Role</Button>
      </Col>
    </Row>
    )
  }

  render() {
    return (
      <Container className="adminContainer" fluid>
        {this.props.roles.map(role => (
          <Fragment key={role.ID}>{this.props.editRole.id === role.ID ? this.editRow(role) : this.standardRow(role)}</Fragment>
        ))}
        {this.addRow()}
      </Container>
    );
  }
}

export default AdminRoles;